module.exports = __webpack_public_path__ + "img/25.e95bd2c3.webp";